/* global slideToggle */

const toggleMegaMenu = (parentElem, dropdown) => {
  parentElem.classList.toggle('is-open-submenu');
  slideToggle(dropdown, 300, 'block');
};

// Open Mega menu sub items - Mobile
attachEvent('.mega-menu__title--main.has-sub-menu', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const parentElem = ev.target.closest('.mega-menu__item');
    const dropdown = parentElem.querySelector('.mega-menu__item-inner-wrapper');
    toggleMegaMenu(parentElem, dropdown);
    ev.preventDefault();
  }
});

attachEvent('.mega-menu__item-inner-wrapper .mega-menu__title.has-sub-menu', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const parentElem = ev.target.closest('.mega-menu__item-inner-wrapper');
    const dropdown = parentElem.querySelector('.mega-menu__item-dropdown');
    toggleMegaMenu(parentElem, dropdown);
    ev.preventDefault();
  }
});
